import { Component } from '@angular/core';
import { AbstractControl, FormBuilder,ValidationErrors, FormControl, FormGroup,ValidatorFn,Validators } from '@angular/forms';
import { Route, Router,ActivatedRoute } from '@angular/router';
import { iif } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UserService } from 'src/app/services/user.service';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';

@Component({
  selector: 'app-reset-passwd',
  templateUrl: './reset-passwd.component.html',
  styleUrls: ['./reset-passwd.component.css']
})
export class ResetPasswdComponent {
  username :  string|undefined;
  password : string|undefined;
  resetFG! : FormGroup
  nameControl = new FormControl('');
  key : String ="";
  invalidCredentialMsg : boolean=false;
  constructor(private toastMsgService : ToastmsgService,
    private fb : FormBuilder,
    private loginService : LoginService,    private customValidator : CustomValidatorsService,
    private route: ActivatedRoute,
    private router : Router,
    private userservice : UserService,
    private userinfo : UserInfoService) {

  }
  
  ngOnInit(): void {
    const routeParams = this.route.snapshot.queryParams;
    this.key = routeParams['authCode'];
  
    this.resetFG=this.fb.group({
      
      "password" : ['',this.customValidator.customPasswordValidator({pattern : "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",msg:"Invalid pattern"})],
      "confirmPassword" : ['',this.confirmPasswordValidator()]
    })
  }
  visibility_off:boolean=false;
  passwordType: string = 'password';
  visibility_of:boolean=false;
  conpasswordType:string='password'
  getControlErrMsg(control : AbstractControl) {
    return control?.errors?.['invalidMsg']
  }
  confirmPasswordValidator = (): ValidatorFn => {
    return (control : AbstractControl) : ValidationErrors|null => {
      if(!control.value) {
        return {
          invalidMsg: "Please enter confirm password!"
        };
      }
      const passwordControl=this.resetFG.controls['password'];
      if(passwordControl.value !=control.value) {
        return {
          invalidMsg: "password mismatch!"
        };
      } else {
        return null;
      }
    };
  }

togglePassword(){
    if(this.passwordType == 'password'){
        this.passwordType = 'text';
        this.visibility_off=true;
        
    } else {
        this.passwordType = 'password';
        this.visibility_off=false;
    }}
    toggleconfirmPassword(){
      if(this.conpasswordType == 'password'){
        this.conpasswordType = 'text';
        this.visibility_of=true;
        
    } else {
        this.conpasswordType = 'password';
        this.visibility_of=false;
    }
    }
    
async resetPasswd() {
 
  let request:any= {};
  request['authCode'] = this.key;
  request['newPassword'] = this.resetFG.value.password;
  this.loginService.resetPasswd(request)
    .subscribe({next : (res)=> {
      let data:any={message:"",success:""}
      data = res
      if(data.message==="Ok"){
       
        this.toastMsgService.setMsg({msg : "Password saved Successfully!",msgTitle : "Success",msgType : "I"});
        this.router.navigate(["/partner_login"]);
       }else if(data.message==="TOKEN_ALREADYUSED"){
        this.toastMsgService.setMsg({msg : "Token already used",msgTitle : "Warning", msgType : "W"});

       }
     
    },error : (err) => {
     
      this.toastMsgService.setMsg({msg : "Failed to Reset Password",msgTitle : "Warning", msgType : "W"});

      }})
   
  }
}
